import store from 'store2';


export function getUsername () {
    return store.get("Auth_un") || "";
}
export function setUsername (username) {
    store.set("Auth_un", username);
}
export function getPassword () {
    return store.get("Auth_pw") || "";
}  
export function setPassword (password) {
    store.set("Auth_pw", password);
}

export function getSelectedProject () {
    return store.get("SelectedProject");
}

export function setSelectedProject (project) {
    store.set("SelectedProject", project);
}

export function getSelectedViewId () {
    return store.get("SelectedViewId");
}

export function setSelectedViewId (viewId) {
    store.set("SelectedViewId", viewId);
}

export function getOnClickStatus(){
    return store.get("openOnClickStatus")
}

export function setOnClickStatus(status){
    store.set("openOnClickStatus", status)
}

export function getChartHeight(){
    return (store.get("ChartHeight") ? JSON.parse(store.get("ChartHeight")) : 1500)
}

export function setChartHeight(height){
    store.set("ChartHeight", JSON.stringify(height))
}

export function getHideProjects(){
    return (store.get("hideProjects") ? JSON.parse(store.get("hideProjects")) : []);
}

export function setHideProjects(projects){
    store.set("hideProjects", JSON.stringify(projects))
}
